import { ConversationActivity } from '../types/conversationActivity';
import { ConversationActivityType } from '../types/atendimentoEnums';
import { formatLeadTemperatureLabel, isLeadTemperatureCode } from './leadTemperatureDisplay';

interface TagActivityMetadata {
  labelId?: string;
  labelName?: string;
  labelDescription?: string;
  appliedByBot?: boolean;
  actorLabel?: string;
}

const resolveTagDisplayName = (labelName?: string, labelDescription?: string | null): string | null => {
  const trimmedDescription = labelDescription?.trim();
  if (trimmedDescription)
  {
    return trimmedDescription;
  }

  const trimmedName = labelName?.trim();
  if (!trimmedName)
  {
    return null;
  }

  if (isLeadTemperatureCode(trimmedName))
  {
    return formatLeadTemperatureLabel(trimmedName, null);
  }

  return trimmedName;
};

const parseTagActivityMetadata = (metadata?: string | null): TagActivityMetadata | null => {
  if (!metadata?.trim())
  {
    return null;
  }

  try
  {
    return JSON.parse(metadata) as TagActivityMetadata;
  }
  catch
  {
    return null;
  }
};

export const formatConversationActivityDetail = (activity: ConversationActivity): string | null => {
  if (activity.reason?.trim())
  {
    return activity.reason.trim();
  }

  const metadata = parseTagActivityMetadata(activity.metadata);
  if (!metadata)
  {
    return null;
  }

  const displayName = resolveTagDisplayName(metadata.labelName, metadata.labelDescription);
  if (!displayName)
  {
    return null;
  }

  if (activity.activityType === ConversationActivityType.TagApplied)
  {
    let detail = `Etiqueta «${displayName}»`;

    if (metadata.actorLabel?.trim())
    {
      detail += ` · ${metadata.actorLabel.trim()}`;
    }
    else if (metadata.appliedByBot)
    {
      detail += ' · Automação';
    }

    return detail;
  }

  if (activity.activityType === ConversationActivityType.TagRemoved)
  {
    return `Etiqueta «${displayName}» removida`;
  }

  return null;
};
